import * as React from 'react';
import { createComponent } from '@lit/react';
import { Theme as SpTheme } from '@spectrum-web-components/theme';

import '@spectrum-web-components/theme/sp-theme.js';

export const Theme = createComponent({
    displayName: 'Theme',
    elementClass: SpTheme,
    react: React,
    tagName: 'sp-theme',
    events: {},
});

export type ThemeType = EventTarget & SpTheme;
